module.exports = __webpack_public_path__ + "img/img11.875c699c.svg";